<template>
  <div class="doctorList">

    <div class="inpBox">
      <page_title></page_title>
      <div class="inpBox_inp">
        <a-input ref="userNameInput" @keyup="inpChange" v-model="keywords" placeholder="请输入姓名查询">
          <a-icon slot="prefix" type="search" />
          <a-icon slot="suffix" @click="clear" v-show="keywords" type="close-circle" />
        </a-input>
      </div>

    </div>

    <div class="speaker_list_par2023">
      <ul class="speaker_list">
        <li v-for="(key,list) in dataList" :key="list">
          <p class="lw_aa" :class="'letter_'+list"   v-show="!keywords">
            <span :id="'letter_'+list" class="lw_bb"></span>
            <span class="zimu">{{list}}</span>
          </p>
          <dl>
            <dd v-for="speaker in key" :key="speaker.id" class="removeyellow" @click="gotoDoctorDetail5(speaker.id)">
              <div class="avatar" ng-click="gotoDoctorDetail5(speaker.id)">
                <img :src="speaker.head_img" v-show="speaker.head_img">
                <img src="@/assets/noImg.webp" v-show="!speaker.head_img">
              </div>
              <div class="right por now" style="padding-right: 10px;" :class="{'perfect-border-bottom':!keywords}"
                ng-click="gotoDoctorDetail5(speaker.id)">

                <div class="stand_flex">
                  <p class="speaker_name" style="flex-grow: 1;">{{speaker.name}}</p>
                </div>
                <div class="stand_flex" style="align-items: flex-start;">
                  <p class="hospital">{{speaker.hospital_name}}</p>
                </div>
                <div class="task_list perfect-border-top" v-if="speaker.tasks&&keywords">
                  <p v-for="(index,task) in speaker.tasks" :key="index" class="task_item">
                    <i class="circle"></i>
                    <span>
                      <span>【{{task.hall}}</span>
                      <span>-</span>
                      <span ng-if="task.identity==1">讲者】</span>
                      <span ng-if="task.identity==2">主持】</span>
                      <span ng-if="task.identity==3">点评】</span>
                      <span ng-if="task.identity==4">主席】</span>
                      <span ng-if="task.identity==5">主持及点评】</span>
                      <span ng-if="task.identity==6">术者】</span>
                    </span>
                    <span ng-bind-html="task.task"></span>
                  </p>
                </div>
              </div>
            </dd>
          </dl>
        </li>
      </ul>

      <div v-show='!keywords' class="letter_index" ng-show="!keywords">
        <ul>
          <li v-for="(key,list) in dataList" :key="list" @click="gotoLetter(list)">
            <i></i>
            <span>{{list}}</span>
          </li>
        </ul>
      </div>

      <div class="nomore">没有更多了</div>
    </div>
  </div>
</template>

<script>
import page_title from './components/page_title.vue';
import $ from 'jquery'
export default {
  components: { page_title },
  props: ["sharePower"],
  data() {
    return {
      keywords: '',
      dataList: {}
    }
  },
  created() {
    this.getINfo('')
  },
  mounted() {
  },
  methods: {
    abcClick(key) {

      console.log(document.documentElement.scrollTop)
      document.documentElement.scrollTop = document.documentElement.scrollTop - 200
      var h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      console.log(h)

      // var letter_top = document.querySelectorAll(".letter_" + key)[0].scrollTop; 
      // letter_top = letter_top - 90 
      // console.log(document.querySelectorAll(".letter_" + key)[0].scrollTop)
      // $('html,body').animate({
      // scrollTop: letter_top
      // }, 300);
    },
    gotoDoctorDetail5(id) {
      this.$router.push('/CZ_doctor_data?id=' + id)
      console.log(id)
    },
    clear() {
      this.keywords = ''
      this.getINfo('')
    },
    inpChange() {
      this.getINfo(this.keywords)
      console.log(this.keywords)
    },
    getINfo(data) {
      this.dataList = {
        "C": [
          {
            "id": 228,
            "name": "蔡志康",
            "hospital_name": "上海市浦东新区公利医院",
            "head_img": "/uploads/070e101b64e5ab2c147faf977889baf1.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 251,
            "name": "曹达龙",
            "hospital_name": "复旦大学附属肿瘤医院",
            "head_img": "/uploads/ebe05369e67bb82f7c7f04a002efb07d.jpg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 283,
            "name": "曹洁",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/2d9ef795e754f1b1379bbd1793b54cd7.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 309,
            "name": "曹万里",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/5c8695dc6e6f80a0180f62afc933290d.jpg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 208,
            "name": "常易凡",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/6124e94646421a62d8884195e1af0abf.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 71,
            "name": "陈斌",
            "hospital_name": "厦门大学附属第一医院",
            "head_img": "/uploads/06e2885e030edea78099885384e7a86c.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 285,
            "name": "陈斌",
            "hospital_name": "上海交通大学医学院附属第六人民医院",
            "head_img": "/uploads/22c391c784327986093a1b98e1b6773c.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 192,
            "name": "陈刚",
            "hospital_name": "复旦大学附属金山医院",
            "head_img": "/uploads/65a36087cd402f669a81d51e538e1756.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 204,
            "name": "陈海戈",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/42da29af83e73b8044f93b644bede0cb.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 298,
            "name": "陈杰",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/b324fa2f3579865ee98a8ff969808a41.jpg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 19,
            "name": "陈明",
            "hospital_name": "东南大学附属中大医院",
            "head_img": "/uploads/ad0a59736d9e86f5f28c8f1ba5db9eda.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 308,
            "name": "陈明",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/6e0049bfa84a24dd236ce81069ce2de8.jpg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 252,
            "name": "陈奇",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/229ea5acdbf9e96bf1345f7a0ce39644.jpg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 266,
            "name": "陈嵘",
            "hospital_name": "上海交通大学医学院附属第六人民医院",
            "head_img": "/uploads/be0d9fda42916abceadb8d62fc34a905.jpg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 207,
            "name": "陈锐",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/b65b7d313780caed9a254c7f62884d6a.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 231,
            "name": "陈伟",
            "hospital_name": "复旦大学附属中山医院",
            "head_img": "/uploads/e527bd38004a0e2c9629abd329582d92.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 202,
            "name": "陈勇辉",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/4ba9df952a87751bfc8d46b78d87c340.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 74,
            "name": "陈忠",
            "hospital_name": "华中科技大学同济医学院附属同济医院",
            "head_img": "/uploads/175f19c9e809085ef85a43f125b4ea82.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 27,
            "name": "程继文",
            "hospital_name": "广西医科大学第一附属医院",
            "head_img": "/uploads/3bf0bffa28fd8bc4960aa47452cbb296.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 288,
            "name": "程欣",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/4efda993fc2d1764c33896874f7f738f.jpeg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 73,
            "name": "程跃",
            "hospital_name": "宁波大学附属第一医院",
            "head_img": "/uploads/c9da2367804c8ed08f1fde14ac46b3f6.jpg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 261,
            "name": "储传敏",
            "hospital_name": "上海中医药大学附属曙光医院",
            "head_img": "/uploads/f1635841776aa254cebdce2828d2dac9.jpg",
            "name_Initial": "C",
            "sort": 0
          },
          {
            "id": 284,
            "name": "崔蓉",
            "hospital_name": "复旦大学附属中山医院",
            "head_img": "/uploads/16651a7a5b91e9fad7cbb9e1e970d6a5.jpeg",
            "name_Initial": "C",
            "sort": 0
          }
        ],
        "D": [
          {
            "id": 275,
            "name": "达骏",
            "hospital_name": "上海交通大学医学院附属第九人民医院",
            "head_img": "/uploads/3f99d72b4c855980e0c7fe05bf523299.jpg",
            "name_Initial": "D",
            "sort": 0
          },
          {
            "id": 238,
            "name": "戴继灿",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/5bd3a4640a3b7c684e0192d334f23d08.jpg",
            "name_Initial": "D",
            "sort": 0
          },
          {
            "id": 302,
            "name": "丁晔磊",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/339586ac27467eaf3cab1c1dcdd3f513.jpg",
            "name_Initial": "D",
            "sort": 0
          },
          {
            "id": 215,
            "name": "董柏君",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/b55d69f3ac61cd8bc13dc144b90d9d42.jpg",
            "name_Initial": "D",
            "sort": 0
          }
        ],
        "F": [
          {
            "id": 3,
            "name": "范先群",
            "hospital_name": "上海交通大学",
            "head_img": "/uploads/35d4609b2720347f61e613a579c572cd.jpeg",
            "name_Initial": "F",
            "sort": 0
          },
          {
            "id": 301,
            "name": "房晓",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/9aa6326fe6a855877c63c5469620cbe2.jpg",
            "name_Initial": "F",
            "sort": 0
          },
          {
            "id": 219,
            "name": "冯陈陈",
            "hospital_name": "复旦大学附属华山医院",
            "head_img": "/uploads/6b37e94a996b279ed4ce24206f213941.jpeg",
            "name_Initial": "F",
            "sort": 0
          },
          {
            "id": 34,
            "name": "傅斌",
            "hospital_name": "南昌大学第一附属医院",
            "head_img": "/uploads/8a9f5cd3b06f7c1ac66268b01e58ea38.jpg",
            "name_Initial": "F",
            "sort": 0
          },
          {
            "id": 198,
            "name": "傅强",
            "hospital_name": "上海交通大学医学院附属第六人民医院",
            "head_img": "/uploads/af0de3d778dc7ab704d47bd88a7b5d91.png",
            "name_Initial": "F",
            "sort": 0
          }
        ],
        "G": [
          {
            "id": 293,
            "name": "甘华磊",
            "hospital_name": "复旦大学附属肿瘤医院",
            "head_img": "/uploads/67e3a3a1fb0cc6ab589afc822b4e9e8b.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 212,
            "name": "高栋",
            "hospital_name": "中国科学院分子细胞科学卓越创新中心",
            "head_img": "/uploads/7e902506783787a018036eca375f56f1.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 282,
            "name": "高连娣",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/839c857cc55976df24c83ba15b3af680.png",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 272,
            "name": "高鹏",
            "hospital_name": "复旦大学附属华山医院",
            "head_img": "/uploads/79db3479adc6fecd3728545002905915.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 185,
            "name": "高小峰",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/c1671c4d60e50ed31da75bfc1a2e19ab.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 184,
            "name": "高旭",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/c13ac7969b14f116f7bab658b270ad3b.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 40,
            "name": "葛京平",
            "hospital_name": "中国人民解放军东部战区总医院",
            "head_img": "/uploads/b85540e56f25efb9236b7ed385aadfc9.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 46,
            "name": "龚侃",
            "hospital_name": "北京大学第一医院",
            "head_img": "/uploads/1148d46f118203ea98ea7ddb7a1dd1c0.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 217,
            "name": "龚旻",
            "hospital_name": "复旦大学附属浦东医院",
            "head_img": "/uploads/1a0679330343cfdaccf2f9f1d4382a81.jpeg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 18,
            "name": "苟欣",
            "hospital_name": "重庆医科大学附属第一医院",
            "head_img": "/uploads/02682e6a29c716724f559002c2512097.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 86,
            "name": "古迪",
            "hospital_name": "广州医科大学附属第一医院",
            "head_img": "/uploads/327a236150e55f849129cc11f1212c50.png",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 230,
            "name": "谷宝军",
            "hospital_name": "上海交通大学医学院附属第六人民医院",
            "head_img": "/uploads/cbef9d50b500450ed1fd9ee384d7ce17.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 271,
            "name": "顾斌",
            "hospital_name": "上海市浦东新区人民医院",
            "head_img": "/uploads/a40541d48258b56b9f98cb3f454a8c40.jpg",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 289,
            "name": "顾珺",
            "hospital_name": "上海交通大学医学院附属新华医院",
            "head_img": "/uploads/3511734136ebbc2fcd9b0107e8a09ac8.png",
            "name_Initial": "G",
            "sort": 0
          },
          {
            "id": 189,
            "name": "郭剑明",
            "hospital_name": "复旦大学附属中山医院",
            "head_img": "/uploads/794f28825e81dc45d63445edad943535.jpg",
            "name_Initial": "G",
            "sort": 0
          }
        ],
        "H": [
          {
            "id": 22,
            "name": "郝宗耀",
            "hospital_name": "安徽医科大学第一附属医院",
            "head_img": "/uploads/e7cc259aa22a011c6eec455c6991a1cb.jpeg",
            "name_Initial": "H",
            "sort": 0
          },
          {
            "id": 246,
            "name": "何威",
            "hospital_name": "上海交通大学医学院附属瑞金医院",
            "head_img": "/uploads/c6a5b168fc863456b5a7205ae39979c8.jpg",
            "name_Initial": "H",
            "sort": 0
          },
          {
            "id": 15,
            "name": "侯建全",
            "hospital_name": "苏州大学附属独墅湖医院",
            "head_img": "/uploads/079f84120c01c6a760da8d6d3679aadc.jpeg",
            "name_Initial": "H",
            "sort": 0
          },
          {
            "id": 268,
            "name": "胡巍",
            "hospital_name": "复旦大学附属浦东医院",
            "head_img": "/uploads/0a637652004d0f14abe0b189b1c4eff9.jpeg",
            "name_Initial": "H",
            "sort": 0
          },
          {
            "id": 220,
            "name": "胡晓勇",
            "hospital_name": "上海交通大学医学院附属第六人民医院",
            "head_img": "/uploads/07955d061145a02773b0c4202f3ef860.jpeg",
            "name_Initial": "H",
            "sort": 0
          },
          {
            "id": 249,
            "name": "黄吉炜",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/daad24508b6792caf8369fe479e9cbe2.jpg",
            "name_Initial": "H",
            "sort": 0
          },
          {
            "id": 10,
            "name": "黄健",
            "hospital_name": "中山大学孙逸仙纪念医院",
            "head_img": "/uploads/70d3131b5bc49f0a72161277d58e8780.jpeg",
            "name_Initial": "H",
            "sort": 0
          },
          {
            "id": 54,
            "name": "黄玉华",
            "hospital_name": "苏州大学附属第一医院",
            "head_img": "/uploads/17489cf2d8b1325673e15f5afc230ce2.jpg",
            "name_Initial": "H",
            "sort": 0
          }
        ],
        "J": [
          {
            "id": 303,
            "name": "季名飞",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/b5130ddff3abb2d3af631e4c21b400c5.jpg",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 269,
            "name": "贾国金",
            "hospital_name": "复旦大学附属金山医院",
            "head_img": "/uploads/a21659a30517a639ceb0d158eb8441c4.JPG",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 56,
            "name": "贾占奎",
            "hospital_name": "郑州大学第一附属医院",
            "head_img": "/uploads/6024dd5ae60f2015a1828192be407c3a.jpg",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 39,
            "name": "江军",
            "hospital_name": "陆军特色医学中心（大坪医院）",
            "head_img": "/uploads/594354f87726880e698b6899f4ba60a4.jpeg",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 196,
            "name": "姜昊文",
            "hospital_name": "复旦大学附属华山医院",
            "head_img": "/uploads/88f0ebe20c3848eaa6989da14ccc7f8d.jpg",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 79,
            "name": "姜华",
            "hospital_name": "东南大学附属中大医院",
            "head_img": "/uploads/a1243e1f76c0e2a66b258fb168beb19f.jpg",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 52,
            "name": "蒋军辉",
            "hospital_name": "宁波大学附属第一医院",
            "head_img": "/uploads/af1ecccd2dbb0ad4319bb94042365d25.jpeg",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 295,
            "name": "蒋琪",
            "hospital_name": "上海交通大学附属第一人民医院",
            "head_img": "/uploads/1e187748bd4750f6d3c81ed888e35808.jpeg",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 5,
            "name": "蒋欣泉",
            "hospital_name": "上海交通大学医学院附属第九人民医院",
            "head_img": "/uploads/c216d4853f8aa12e83b916d3cd55b798.jpg",
            "name_Initial": "J",
            "sort": 0
          },
          {
            "id": 227,
            "name": "荆翌峰",
            "hospital_name": "上海交通大学医学院附属第一人民医院",
            "head_img": "/uploads/36c01ad151f980fdcdce0d659d069795.jpg",
            "name_Initial": "J",
            "sort": 0
          }
        ],
        "L": [
          {
            "id": 237,
            "name": "李超",
            "hospital_name": "同济大学附属同济医院（上海市同济医院）",
            "head_img": "/uploads/c175094a7fa25f8705f9cc565df38cb5.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 294,
            "name": "李杜渐",
            "hospital_name": "同济大学附属第四人民医院",
            "head_img": "/uploads/17ed361d83051934a9c502921cc00236.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 21,
            "name": "李恭会",
            "hospital_name": "浙江大学医学院附属邵逸夫医院",
            "head_img": "/uploads/2dc0f98b314e46d6ebf4e4393b86c6be.jpg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 243,
            "name": "李建辉",
            "hospital_name": "上海计生所医院",
            "head_img": "/uploads/853495879072fc6d27eafd3cd237cc1d.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 47,
            "name": "李建兴",
            "hospital_name": "清华大学附属北京清华长庚医院",
            "head_img": "/uploads/8ba3f7efc30539340936581d0454a981.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 4,
            "name": "李劲松",
            "hospital_name": "中国科学院分子细胞科学卓越创新中心",
            "head_img": "/uploads/68d9a47d6255ff9f9e831135283bd1ea.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 262,
            "name": "李凌",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/182dd21cfc45714d6657ad41911ca858.jpg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 235,
            "name": "李朋",
            "hospital_name": "上海交通大学医学院附属第一人民医院",
            "head_img": "/uploads/7ccda74baed5fd0386a19f6a511215f6.jpg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 92,
            "name": "李鹏",
            "hospital_name": "湖州市中心医院",
            "head_img": "/uploads/9f7fb5b5e76e8221e7e611869ad62bd4.jpg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 69,
            "name": "李响",
            "hospital_name": "四川大学华西医院",
            "head_img": "/uploads/04b5822f24b99a9a7c380920bffc5b9e.jpg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 45,
            "name": "李学松",
            "hospital_name": "北京大学第一医院",
            "head_img": "/uploads/0b52b10bd5f7597472b8f6883b724e1b.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 199,
            "name": "李铮",
            "hospital_name": "上海交通大学附属第一人民医院",
            "head_img": "/uploads/ed85d550a2e6f42cf49119209352d6f2.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 62,
            "name": "刘犇",
            "hospital_name": "浙江大学医学院附属第一医院",
            "head_img": "/uploads/cb08424ab603e9bbcadf90860d7c6c41.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 186,
            "name": "刘冰",
            "hospital_name": "海军军医大学第三附属医院（上海东方肝胆外科医院）",
            "head_img": "/uploads/aefa9c77c3b1e6f2f8c6905ef5759c75.jpg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 57,
            "name": "刘存东",
            "hospital_name": "南方医科大学第三附属医院",
            "head_img": "/uploads/140fe43786c1c8f9ffb1ec7774ad8099.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 314,
            "name": "刘冬",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/c784ffcdb5389698380e50c75688d2ed.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 25,
            "name": "刘久敏",
            "hospital_name": "广东省人民医院",
            "head_img": "/uploads/7cd43c8872cf57803de02e072d8218fe.jpg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 7,
            "name": "刘默芳",
            "hospital_name": "中科院上海生化与细胞所",
            "head_img": "/uploads/758e30efdcdac58d94aec295eef4e891.jpg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 260,
            "name": "刘荣福",
            "hospital_name": "上海市杨浦区中心医院",
            "head_img": "/uploads/b0f596e451e1886f8baeb0d76332d883.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 93,
            "name": "刘永达",
            "hospital_name": "广州医科大学附属第一医院",
            "head_img": "/uploads/3cead8e6ab69786e5666e74fa905bd20.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 209,
            "name": "刘玉杉",
            "hospital_name": "上海交通大学医学院附属第九人民医院",
            "head_img": "/uploads/71d6f1eb05e045c4a4d9b6348208a494.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 94,
            "name": "刘志宇",
            "hospital_name": "大连医科大学附属第二医院",
            "head_img": "/uploads/05879f7c78a6dda797cb6e9bbe89fbad.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 232,
            "name": "卢慕峻",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/335aad2c461328c6126a4a40d722b5cf.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 253,
            "name": "鲁军",
            "hospital_name": "上海交通大学附属第一人民医院",
            "head_img": "/uploads/2d57e8384a4490ab8136c27ee031af69.jpeg",
            "name_Initial": "L",
            "sort": 0
          },
          {
            "id": 41,
            "name": "罗俊航",
            "hospital_name": "中山大学附属第一医院",
            "head_img": "/uploads/52aedaba526112c19610b612c92a709a.jpeg",
            "name_Initial": "L",
            "sort": 0
          }
        ],
        "M": [
          {
            "id": 42,
            "name": "马鑫",
            "hospital_name": "中国人民解放军总医院",
            "head_img": "/uploads/305af107524de456165e19d51eca9e65.jpg",
            "name_Initial": "M",
            "sort": 0
          },
          {
            "id": 89,
            "name": "马子芳",
            "hospital_name": "衡阳市中心医院",
            "head_img": "/uploads/5afc50a6b92723cc5254cff8a2edc58e.jpeg",
            "name_Initial": "M",
            "sort": 0
          },
          {
            "id": 80,
            "name": "孟祥虎",
            "hospital_name": "江苏省人民医院",
            "head_img": "/uploads/1db46a151f312755d84692c6b43ee3fd.jpg",
            "name_Initial": "M",
            "sort": 0
          },
          {
            "id": 281,
            "name": "孟晓红",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/8f44329ec70bca1e8a1586f069903326.jpeg",
            "name_Initial": "M",
            "sort": 0
          }
        ],
        "N": [
          {
            "id": 67,
            "name": "牛亦农",
            "hospital_name": "首都医科大学附属北京朝阳医院",
            "head_img": "/uploads/84f0528200e5a06b485810ac56f0189c.jpg",
            "name_Initial": "N",
            "sort": 0
          }
        ],
        "P": [
          {
            "id": 203,
            "name": "潘家骅",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/88927d07279b6fb81302c04f9b450842.jpg",
            "name_Initial": "P",
            "sort": 0
          },
          {
            "id": 229,
            "name": "彭波",
            "hospital_name": "同济大学附属第十人民医院",
            "head_img": "/uploads/be9e68af27148552bbc4f2a17adadf9c.jpeg",
            "name_Initial": "P",
            "sort": 0
          },
          {
            "id": 278,
            "name": "彭飞",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/8679d2047c7461b2cecb4a0be9a3117d.jpeg",
            "name_Initial": "P",
            "sort": 0
          },
          {
            "id": 276,
            "name": "彭泳涵",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/50a5a9b9678474bfa2dbec632c1c46f9.jpg",
            "name_Initial": "P",
            "sort": 0
          },
          {
            "id": 64,
            "name": "平浩",
            "hospital_name": "首都医科大学附属北京同仁医院",
            "head_img": "/uploads/987fffb547ea8003a87baaf044b8e1db.jpeg",
            "name_Initial": "P",
            "sort": 0
          },
          {
            "id": 236,
            "name": "平萍",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/5bb0390aa8b9606d1171a8db8ab043c0.jpg",
            "name_Initial": "P",
            "sort": 0
          }
        ],
        "Q": [
          {
            "id": 240,
            "name": "齐隽",
            "hospital_name": "上海交通大学医学院附属新华医院",
            "head_img": "/uploads/5f5e70ec0328e45e81451d2a92853578.jpeg",
            "name_Initial": "Q",
            "sort": 0
          },
          {
            "id": 270,
            "name": "钱海宁",
            "hospital_name": "上海交通大学医学院附属同仁医院",
            "head_img": "/uploads/508dccf8a496642d44c70fec59f023d0.jpg",
            "name_Initial": "Q",
            "sort": 0
          },
          {
            "id": 213,
            "name": "秦骏",
            "hospital_name": "中国科学院上海营养与健康研究所",
            "head_img": "/uploads/f972b4aa9f7a67777f3c12c23756c421.png",
            "name_Initial": "Q",
            "sort": 0
          },
          {
            "id": 30,
            "name": "秦卫军",
            "hospital_name": "空军军医大学第一附属医院（西京医院）",
            "head_img": "/uploads/4de3808fd86f5722c0e72cf1d2308b3a.jpg",
            "name_Initial": "Q",
            "sort": 0
          }
        ],
        "R": [
          {
            "id": 306,
            "name": "任吉忠",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/105befd900ab0414a9082edcf644fbe5.jpg",
            "name_Initial": "R",
            "sort": 0
          },
          {
            "id": 297,
            "name": "任善成",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/cd9e8a5f2ff58a521da939f24bebd19e.jpeg",
            "name_Initial": "R",
            "sort": 0
          }
        ],
        "S": [
          {
            "id": 66,
            "name": "谌科",
            "hospital_name": "华中科技大学同济医学院附属同济医院",
            "head_img": "/uploads/62036e48ef2a8de4773ad20fe2e49203.jpg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 254,
            "name": "邵怡",
            "hospital_name": "上海交通大学医学院附属第一人民医院",
            "head_img": "/uploads/5fdfae4e37235ec6aa72ca8e3757fad4.jpg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 225,
            "name": "邵远",
            "hospital_name": "上海交通大学医学院附属瑞金医院",
            "head_img": "/uploads/97fca138ab2fd2afc43e92861ec37857.jpg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 211,
            "name": "沈兵",
            "hospital_name": "上海申康医院发展中心",
            "head_img": "/uploads/2c79016ef6fa418d89c12c56b37df3ab.jpg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 256,
            "name": "盛璐",
            "hospital_name": "复旦大学附属华东医院",
            "head_img": "/uploads/1499a79961545bac5d557dbf3298232c.jpg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 321,
            "name": "施国海",
            "hospital_name": "复旦大学附属肿瘤医院",
            "head_img": "/uploads/5a101c78c6f048853ef636df9fc5cf64.jpg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 216,
            "name": "施国伟",
            "hospital_name": "复旦大学附属上海市第五人民医院",
            "head_img": "/uploads/cf8d7b40c646de09c54960f22206942d.jpeg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 304,
            "name": "时佳子",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/90c2db537a29ef666a860f7a071afc0d.jpg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 316,
            "name": "宋丽",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/12aae9253f6717f9ccb3e0512da21943.png",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 85,
            "name": "孙红玲",
            "hospital_name": "广州医科大学第一附属医院",
            "head_img": "/uploads/19b9877aae32a056c3a82c274aabfbd5.jpeg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 51,
            "name": "孙洵",
            "hospital_name": "昆明市第一人民医院",
            "head_img": "/uploads/726d15cc4fe7a5bc5171a1821d4d4fec.jpeg",
            "name_Initial": "S",
            "sort": 0
          },
          {
            "id": 292,
            "name": "孙忠全",
            "hospital_name": "复旦大学附属华东医院",
            "head_img": "/uploads/e3ed07459dd274ce207ba2aac5165d12.jpeg",
            "name_Initial": "S",
            "sort": 0
          }
        ],
        "T": [
          {
            "id": 255,
            "name": "谭剑敏",
            "hospital_name": "上海市静安区闸北中心医院",
            "head_img": "/uploads/af37cb71a38a9191f4ddbfb2a2cf48e0.jpeg",
            "name_Initial": "T",
            "sort": 0
          },
          {
            "id": 28,
            "name": "唐伟",
            "hospital_name": "重庆医科大学附属第一医院",
            "head_img": "/uploads/8806b246a37426b90751f4716e9a344d.jpg",
            "name_Initial": "T",
            "sort": 0
          },
          {
            "id": 70,
            "name": "田龙",
            "hospital_name": "首都医科大学附属北京朝阳医院",
            "head_img": "/uploads/3bdf7cc0020cfa9ae546b9ddca411d88.jpg",
            "name_Initial": "T",
            "sort": 0
          }
        ],
        "W": [
          {
            "id": 311,
            "name": "王安邦",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/8a9c1965ccf7b1de94be917e83f9a5db.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 43,
            "name": "王保军",
            "hospital_name": "中国人民解放军总医院",
            "head_img": "/uploads/66461ae30beab2f6002d4af26af87a57.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 274,
            "name": "王大伟",
            "hospital_name": "上海交通大学医学院附属瑞金医院北部院区",
            "head_img": "/uploads/15098649c52e12ee34aed8a3297babe7.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 81,
            "name": "王德胜",
            "hospital_name": "蚌埠市第二人民医院",
            "head_img": "/uploads/c67f91bccdf7ae52f66ca9057bfc9124.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 33,
            "name": "王东",
            "hospital_name": "四川省人民医院",
            "head_img": "/uploads/1c0a99628b79716670a2313361e4da5b.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 239,
            "name": "王飞翔",
            "hospital_name": "司法鉴定科学研究院",
            "head_img": "/uploads/41dbbcefc004584ad95e3200a3f90b08.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 218,
            "name": "王海峰",
            "hospital_name": "同济大学附属东方医院",
            "head_img": "/uploads/961dc730df4cf5a16d83e9adccb14aa4.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 201,
            "name": "王杭",
            "hospital_name": "复旦大学附属中山医院",
            "head_img": "/uploads/5edaed241a5ac97792d6eaeedb17505f.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 8,
            "name": "王红霞",
            "hospital_name": "上海交通大学医学院附属第一人民医院",
            "head_img": "/uploads/77609d0f84a2ac38f15426763a7afc33.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 2,
            "name": "王红阳",
            "hospital_name": "海军军医大学第三附属医院\n（上海东方肝胆外科医院）",
            "head_img": "/uploads/33ab77c4575325212e67bb2f9177203d.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 63,
            "name": "王建伯",
            "hospital_name": "大连医科大学第一附属医院",
            "head_img": "/uploads/e02b3c6cf041fab1dc655b5466406263.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 300,
            "name": "王军凯",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/aaa6a23a0f3ded3725826f92cc4639a7.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 29,
            "name": "王坤杰",
            "hospital_name": "四川大学华西医院",
            "head_img": "/uploads/e569ddb051f3e1dd4a7b9d47ac54378d.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 241,
            "name": "王磊",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/c3aed280dfd25a106c0364f015229536.png",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 65,
            "name": "王龙",
            "hospital_name": "中南大学湘雅三医院",
            "head_img": "/uploads/33733cc8d00f91e10c19f6ab41d97e67.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 48,
            "name": "王平",
            "hospital_name": "浙江大学医学院附属第一医院",
            "head_img": "/uploads/6b4f4c0e29f2d1092954efe3bbaadb11.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 16,
            "name": "王少刚",
            "hospital_name": "华中科技大学同济医学院附属同济医院",
            "head_img": "/uploads/d169c718f39f24cc85172dd57bc8b5f3.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 75,
            "name": "王涛",
            "hospital_name": "华中科技大学同济医学院附属同济医院",
            "head_img": "/uploads/c382a9100b2b5b2362af81d1a332cbdf.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 265,
            "name": "王伟",
            "hospital_name": "复旦大学附属上海市第五人民医院",
            "head_img": "/uploads/5b1d18b39ebfdf1ca3c0eb82cd56e7dd.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 82,
            "name": "王卫红",
            "hospital_name": "宁波大学第一附属医院",
            "head_img": "/uploads/79f4a5b4275207b095fea1704ab75b00.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 244,
            "name": "王翔",
            "hospital_name": "上海交通大学医学院附属第一人民医院",
            "head_img": "/uploads/87846ee8e76c46659819d0ba0a1f47ee.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 313,
            "name": "王野",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/5ef36f0a105416b95551cc7e66cd907a.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 277,
            "name": "王一惟",
            "hospital_name": "上海交通大学医学院附属第九人民医院",
            "head_img": "/uploads/71069b819eae8e3f24d24070dd0663ab.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 20,
            "name": "王增军",
            "hospital_name": "江苏省人民医院",
            "head_img": "/uploads/742ab87245992755413429943cb7c729.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 55,
            "name": "王志华",
            "hospital_name": "华中科技大学同济医学院附属同济医院",
            "head_img": "/uploads/d87511df878c46b6ec91d08296fbd204.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 312,
            "name": "王志军",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/5b7b82d556c696bd2fc48f1857544fab.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 13,
            "name": "魏强",
            "hospital_name": "四川大学华西医院",
            "head_img": "/uploads/c8d2e1a7314fa05012b32359060fd86f.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 210,
            "name": "温晖",
            "hospital_name": "上海交大医学院附属松江医院",
            "head_img": "/uploads/e591e326f3cc5f1fe987b31e01f520fd.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 84,
            "name": "温惠莉",
            "hospital_name": "湖州市中心医院",
            "head_img": "/uploads/4aead289492d53c2daaf16a34424198d.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 257,
            "name": "温晓飞",
            "hospital_name": "同济大学附属东方医院",
            "head_img": "/uploads/fbbd356feb3b24e7842f394941dfac6d.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 221,
            "name": "文伟",
            "hospital_name": "上海交通大学医学院附属第一人民医院",
            "head_img": "/uploads/7806f37820fa228f89d2965daebbd93c.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 191,
            "name": "吴登龙",
            "hospital_name": "同济大学附属同济医院（上海市同济医院）",
            "head_img": "/uploads/e6af0142e2d2dc1119c1b1e468e9fa27.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 264,
            "name": "吴强",
            "hospital_name": "同济大学附属同济医院（上海市同济医院）",
            "head_img": "/uploads/e34dc153ebfdef900355b854421fc65e.jpg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 60,
            "name": "吴松",
            "hospital_name": "深圳市附属华南医院",
            "head_img": "/uploads/e640b64d0370bfda724a98d3291909a2.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 279,
            "name": "吴小凤",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/177cc75fe3ec95b140b2e60509b1d4ef.jpeg",
            "name_Initial": "W",
            "sort": 0
          },
          {
            "id": 188,
            "name": "吴忠",
            "hospital_name": "复旦大学附属华山医院",
            "head_img": "/uploads/9bd02ef2d4e8b02be45d1015996d1e88.jpg",
            "name_Initial": "W",
            "sort": 0
          }
        ],
        "X": [
          {
            "id": 31,
            "name": "夏丹",
            "hospital_name": "浙江大学医学院附属第一医院",
            "head_img": "/uploads/1665ea252d5fcddde4216b2f22b97fac.jpg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 245,
            "name": "夏国伟",
            "hospital_name": "复旦大学附属华山医院",
            "head_img": "/uploads/50ea22dae2fd5574b8cca6111eb7d9e7.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 273,
            "name": "夏磊",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/0c9457d754f3f5fb05770a35cb803053.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 76,
            "name": "肖恒军",
            "hospital_name": "中山大学附属第三医院",
            "head_img": "/uploads/c299ff55a8a4ad07598c5b271ed1a975.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 50,
            "name": "肖克峰",
            "hospital_name": "深圳市人民医院",
            "head_img": "/uploads/3e799c14e4b230587d2e47adc740b866.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 224,
            "name": "谢华",
            "hospital_name": "上海交通大学医学院附属儿童医院",
            "head_img": "/uploads/82a18d451ced744f98fa23297d989ad9.png",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 12,
            "name": "谢立平",
            "hospital_name": "浙江大学医学院附属第一医院",
            "head_img": "/uploads/571d14f6afd5b394b85ac783f51a2c14.jpg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 11,
            "name": "邢念增",
            "hospital_name": "国家癌症中心/中国医学科学院肿瘤医院",
            "head_img": "/uploads/4d0f3ce52dc19651abdb122b3209ad94.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 318,
            "name": "徐必友",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/7a471132fe76d03291f9eadf6a10d29d.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 193,
            "name": "徐斌",
            "hospital_name": "上海交通大学医学院附属第九人民医院",
            "head_img": "/uploads/b75c7d9fe28226067faa4e7986ff9f18.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 194,
            "name": "徐丹枫",
            "hospital_name": "上海交通大学医学院附属瑞金医院",
            "head_img": "/uploads/46aa9b19ed7ba6df3da21d29756e3bc0.jpg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 190,
            "name": "徐东亮",
            "hospital_name": "上海中医药大学附属曙光医院",
            "head_img": "/uploads/36965661b33e016286e7e024b932acfb.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 72,
            "name": "徐华",
            "hospital_name": "武汉大学中南医院",
            "head_img": "/uploads/eaf884a3747a6871e81e4dd6f2ea72d6.png",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 320,
            "name": "徐纪平",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/301cf72df4fed65c4998508caebe01e1.jpg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 205,
            "name": "徐可",
            "hospital_name": "复旦大学附属华山医院",
            "head_img": "/uploads/6a6271c4cd1de5c733307df411b34291.jpg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 290,
            "name": "徐琼峰",
            "hospital_name": "同济大学附属同济医院",
            "head_img": "/uploads/9a2ea10fc640f7b8d0e28742f73aa56e.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 14,
            "name": "徐万海",
            "hospital_name": "哈尔滨医科大学附属肿瘤医院",
            "head_img": "/uploads/acb08e70500e02e71684f9548d4ed94d.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 310,
            "name": "徐伟东",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/aea101917ca006c700cc7049a070a229.jpg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 286,
            "name": "徐颖",
            "hospital_name": "上海交通大学医学院附属瑞金医院",
            "head_img": "/uploads/de41c28f8be2769257a3e1c03d6eb996.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 197,
            "name": "许传亮",
            "hospital_name": "海军军医大学第一附属医院（上海长海医院）",
            "head_img": "/uploads/5d51050828973255b9d5b5e5e7154a6a.jpg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 36,
            "name": "许可慰",
            "hospital_name": "中山大学孙逸仙纪念医院",
            "head_img": "/uploads/4d4e29bfffed4c18f6d15ecfe452aa24.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 259,
            "name": "许云飞",
            "hospital_name": "同济大学附属第十人民医院",
            "head_img": "/uploads/cade378ab43bedbf55cf63c2850b554e.png",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 200,
            "name": "薛蔚",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/24d8ed95ab38802fe358ae475eabf841.jpeg",
            "name_Initial": "X",
            "sort": 0
          },
          {
            "id": 68,
            "name": "薛学义",
            "hospital_name": "福建医科大学附属第一医院",
            "head_img": "/uploads/d08dccb501d6863adb9dc4204498c219.jpg",
            "name_Initial": "X",
            "sort": 0
          }
        ],
        "Y": [
          {
            "id": 234,
            "name": "鄢阳",
            "hospital_name": "同济大学附属第十人民医院",
            "head_img": "/uploads/c2be7816cb5a41ec6c7745d90f489fed.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 206,
            "name": "杨斌",
            "hospital_name": "同济大学附属第十人民医院）",
            "head_img": "/uploads/c79d9329e6ad52c7df264bd4edc07281.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 187,
            "name": "杨国胜",
            "hospital_name": "同济大学附属东方医院",
            "head_img": "/uploads/9e3c847068a23e558895193a252a2eae.jpeg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 23,
            "name": "杨锦建",
            "hospital_name": "郑州大学第一附属医院",
            "head_img": "/uploads/b9e29ab51e1c7b4c9e84794b7ed317f3.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 87,
            "name": "杨进",
            "hospital_name": "苏北人民医院",
            "head_img": "/uploads/99d14870a45964f34a0d97b4354b8c64.jpeg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 242,
            "name": "杨念钦",
            "hospital_name": "复旦大学附属中山医院",
            "head_img": "/uploads/98bcca25fd90d9ed2436b8e66216ee63.jpeg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 263,
            "name": "杨冉星",
            "hospital_name": "上海交通大学医学院附属第六人民医院",
            "head_img": "/uploads/9ace3418ee3f222f2fecea6347b517d1.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 95,
            "name": "杨小明",
            "hospital_name": "郑州大学第一附属医院",
            "head_img": "/uploads/6b88e3dbc65fb93e4d67171cadf1a2d7.png",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 233,
            "name": "姚海军",
            "hospital_name": "上海交通大学医学院附属第九人民医院",
            "head_img": "/uploads/f94456ceeaa769ec95b1069fb27af3df.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 307,
            "name": "姚亚成",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/afa014c674b4f3ede6810f9fe45923b7.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 296,
            "name": "叶定伟",
            "hospital_name": "复旦大学附属肿瘤医院",
            "head_img": "/uploads/da64a61624341bb69ca8a1e0f19d5f40.png",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 299,
            "name": "阴雷",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/45c3d775609d9abf14491233dfa1f462.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 317,
            "name": "余丹",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/853ddf5f142544d1e8ad85ccd4397bdb.jpeg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 83,
            "name": "余娜",
            "hospital_name": "蚌埠市第二人民医院",
            "head_img": "/uploads/a773b6f60bc1ae8ed1b81c4a9bcc8aca.jpeg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 59,
            "name": "余虓",
            "hospital_name": "华中科技大学同济医学院附属同济医院",
            "head_img": "/uploads/2a4d1ab523c838500f1e1b354c36ec54.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 267,
            "name": "俞国锋",
            "hospital_name": "上海市第六人民医院金山分院（上海市金山区中心医院）",
            "head_img": "/uploads/db8b328fb1200dfacac1c8cae18da7a5.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 6,
            "name": "虞先濬",
            "hospital_name": "复旦大学附属肿瘤医院",
            "head_img": "/uploads/a3d4d271d8439cadff9e1c1dc11a62ce.jpg",
            "name_Initial": "Y",
            "sort": 0
          },
          {
            "id": 88,
            "name": "袁磊",
            "hospital_name": "泗县人民医院",
            "head_img": "/uploads/2a214f1bbe5a3fc9590ede88d0e81702.jpeg",
            "name_Initial": "Y",
            "sort": 0
          }
        ],
        "Z": [
          {
            "id": 17,
            "name": "曾国华",
            "hospital_name": "广州医科大学附属第一医院",
            "head_img": "/uploads/7f1035f570685c7add86eca4cc8fbf95.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 58,
            "name": "曾浩",
            "hospital_name": "四川大学华西医院",
            "head_img": "/uploads/138a3622833b8450943243a1360291e7.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 248,
            "name": "翟炜",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/85c4e38cc1c60a8a82e30c6cb4da4192.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 32,
            "name": "张大宏",
            "hospital_name": "浙江省人民医院",
            "head_img": "/uploads/0df0385dc4567e160a2c2627c23691d0.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 77,
            "name": "张东旭",
            "hospital_name": "宁波市第一医院",
            "head_img": "/uploads/1fc5f7858c1a4a0c1fb10f4de4b1b00a.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 9,
            "name": "张锋",
            "hospital_name": "复旦大学附属妇产科医院",
            "head_img": "/uploads/bb8f70462616cc95fe44f73465bf960c.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 61,
            "name": "张国玺",
            "hospital_name": "赣南医学院第一附属医院",
            "head_img": "/uploads/02f9d1ba15eabf84263b1c12b5d735e3.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 247,
            "name": "张海梁",
            "hospital_name": "复旦大学附属肿瘤医院",
            "head_img": "/uploads/e703f6dd8dbac3d56674cbf51e777c17.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 78,
            "name": "张明",
            "hospital_name": "吉林大学第二医院",
            "head_img": "/uploads/0d475018aa06bb54120ff585c1428dfb.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 258,
            "name": "张青川",
            "hospital_name": "上海中医药大学附属普陀医院",
            "head_img": "/uploads/3830be0354b2e3f8fc67c667006a27fe.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 38,
            "name": "张树栋",
            "hospital_name": "北京大学第三医院",
            "head_img": "/uploads/993b62b63deba48cc50e00ed2bb63e76.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 1,
            "name": "张旭",
            "hospital_name": "中国人民解放军总医院",
            "head_img": "/uploads/e52b4948431c1249ec281c6ebc567981.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 49,
            "name": "张雪培",
            "hospital_name": "郑州大学第一附属医院",
            "head_img": "/uploads/03b182ec32c53e76284f78760a34cece.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 53,
            "name": "张亚群",
            "hospital_name": "北京医院",
            "head_img": "/uploads/0c6205d043cb5c7bde1e0148b636857a.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 305,
            "name": "张宗勤",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/41ca16cb021a02144af60ba51f34275a.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 24,
            "name": "章小平",
            "hospital_name": "华中科技大学同济医学院附属同济医院",
            "head_img": "/uploads/a1226f5cb7642fe4a32b3a3679bbb3a0.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 315,
            "name": "赵艳丽",
            "hospital_name": "海军军医大学第二附属医院（上海长征医院）",
            "head_img": "/uploads/b44adecb6e2d013d3ddfc96793e2176d.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 26,
            "name": "钟惟德",
            "hospital_name": "广州市第一人民医院",
            "head_img": "/uploads/2f8893f14b5038f085eee8ee82463d34.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 44,
            "name": "周辉霞",
            "hospital_name": "中国人民解放军总医院",
            "head_img": "/uploads/0989c03f925cd02dc66669c8db9a693e.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 96,
            "name": "周利群",
            "hospital_name": "北京大学第一医院",
            "head_img": "/uploads/2c879f2ce385dd558adcf8c843a89722.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 223,
            "name": "周任远",
            "hospital_name": "上海市静安区中心医院",
            "head_img": "/uploads/8fd77cd597153de5a7f4a0954666d865.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 222,
            "name": "周铁",
            "hospital_name": "同济大学附属第四人民医院",
            "head_img": "/uploads/15dc424e77b7f320f2c3aaabc92f50fd.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 291,
            "name": "周文龙",
            "hospital_name": "上海交通大学医学院附属瑞金医院",
            "head_img": "/uploads/81ca185140160a2862d0599f034964ae.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 280,
            "name": "周意",
            "hospital_name": "上海交通大学医学院附属第一人民医院",
            "head_img": "/uploads/3ac0146c0e288257ff58dffeaede68bb.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 37,
            "name": "朱清毅",
            "hospital_name": "南京医科大学第二附属医院",
            "head_img": "/uploads/5b2f553532914dd85e7f3c9777b5959c.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 195,
            "name": "朱汝健",
            "hospital_name": "复旦大学附属浦东医院",
            "head_img": "/uploads/0e0f3838bdac80154f36c2a84fbfe0a5.jpeg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 214,
            "name": "朱耀",
            "hospital_name": "复旦大学附属肿瘤医院",
            "head_img": "/uploads/7ffd65c799065db4e1c9955b4b2695b4.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 226,
            "name": "朱寅杰",
            "hospital_name": "上海交通大学医学院附属仁济医院",
            "head_img": "/uploads/3a583fa307d7b1c00f2a95e9be3cf280.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 250,
            "name": "朱煜",
            "hospital_name": "复旦大学附属肿瘤医院",
            "head_img": "/uploads/39960f878261482c78329baecdc0a9f9.jpg",
            "name_Initial": "Z",
            "sort": 0
          },
          {
            "id": 35,
            "name": "邹晓峰",
            "hospital_name": "赣南医学院第一附属医院",
            "head_img": "/uploads/49a6693064d00283fad8e60366020c1c.jpg",
            "name_Initial": "Z",
            "sort": 0
          }
        ]
      }
    },
    share() {
      let _this = this
      _this.sharePower().then(function (res) {
        _this.WXConfig.wxShowMenu(
          res.data,
          "参会专家",
          "http://shczmn.xoncology.com/uploads/65a6decf8e6204ac814d6a2612d595e8.jpg",
          "2023长征泌尿高峰论坛\r\n6月7日-7月1日",
          "参会专家 | 2023长征泌尿高峰论坛\r\n6月7日-7月1日"
        );
      });
    },
    gotoLetter(key) {
      var letter_top = $(".letter_" + key).offset().top;
      // if ($routeParams.meetingId >= 4) {
      letter_top = letter_top - 55
      // }
      $('html,body').animate({
        scrollTop: letter_top
      }, 300);
    }
  }
}
</script> 

<style lang="less" scoped>
.inpBox {
  position: fixed;
  top: 0;
  width: 100%;
  padding: 0px 0;
  background-color: #fff;
  z-index: 998;
}
.lw_aa {
  position: relative;
}
.lw_bb {
  position: absolute;
  top: -80px;
  width: 10px;
  height: 10px;
}
.nomore {
  text-align: center;
}
.doctorList {
  position: relative;
}
.pof {
  position: fixed;
  top: 0px;
  padding: 10px 5px;
  margin: auto;
  width: 100%;
  max-width: 750px;
  box-sizing: border-box;
  z-index: 9;
  background-color: #caebff;
}
* {
  box-sizing: border-box;
}
.por {
  position: absolute;
  width: 100%;
  height: 35px;
  padding: 5px;
}
.speaker_input {
  width: 100%;
  height: 35px;
  border: 1px solid #979797;
  border-radius: 25px;
  padding-left: 40px;
  -webkit-appearance: none;
  outline: 0;
  -webkit-tap-highlight-color: transparent;
  font-size: 16px !important;
}
.speaker_list_par2023 {
  margin-top: 125px;
  padding: 0px 12px 12px 12px;
  overflow: scroll;
  scroll-behavior: smooth;
}
ul.speaker_list {
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  overflow: scroll;
  scroll-behavior: smooth;
  background-color: #fff;
}
li {
  list-style: none;
}
input,
input:focus {
  font-size: 16px !important;
}

.speaker_list dd {
  background-color: #ffffff;
}

.three_yhzj_ul .active {
  color: #0067a3;
}

.three_yhzj_ul .active .yhzj_foot {
  background: #0067a3;
}
.speaker_list .letter {
  padding: 3px 15px;
  background-color: #f1f1f1;
  font-weight: bolder;
  color: #999;
}
.speaker_list dl {
  margin: 0;
  padding-bottom: 12px;
}
.speaker_list dd {
  position: relative;
  min-height: 80px;
  padding: 0 0 0 90px;
}
.speaker_list li p {
  padding: 3px 0;
}
.speaker_list .avatar {
  display: block;
  position: absolute;
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  top: 10px;
  left: 15px;
}
.speaker_list .avatar img {
  width: 100%;
}
.speaker_list .right {
  padding: 10px 0;
  min-height: 80px;
}
.speaker_list dd:last-child .right {
  background-image: none;
}
.speaker_list dd .speaker_name {
  padding: 7px 0 4px;
  font-size: 16px;
  font-weight: bold;
}
.speaker_list dd .hospital {
  font-weight: 300;
}
.speaker_list .search {
  background-color: #678dd4;
  padding: 5px;
  overflow: hidden;
  position: relative;
}
.speaker_list input {
  width: 80%;
  padding: 10px 25px;
  -webkit-appearance: none;
  border-radius: 24px 0 0 24px;
  border: none;
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
}
.speaker_list input::-webkit-input-placeholder {
  color: #bbb;
}
.speaker_list .icon-sousuo {
  display: inline-block;
  background-color: #fff;
  color: #678dd4;
  border-radius: 0 24px 24px 0;
  width: 20%;
  padding: 0px 0;
  text-align: center;
  font-size: 34px;
  vertical-align: middle;
  line-height: 42px;
  border-left: 2px solid #678dd4;
}
.speaker_list .icon-quxiao {
  display: block;
  position: absolute;
  font-size: 14px;
  background-color: #ccc;
  color: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  right: 24%;
  top: 50%;
  margin-top: -12px;
  text-align: center;
  line-height: 24px;
}
ul.speaker_list {
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
}

.speaker_list_par2023 {
  padding: 0px 12px 12px 12px;
  overflow: auto;
}

.speaker_serch {
  background-color: #caebff !important;
  box-shadow: 0 0 0 0 transparent;
}

.pdt85 {
  padding-top: 90px;
}

.speaker_list .letter span {
  color: #232323;
}
.zimu { 
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px; 
  font-size: 16px;
}
.now {
  width: unset;
}
.sous {
  position: absolute;
  left: 15px;
  top: 15px;
}
.quxiao {
  position: absolute;
  right: 15px;
  top: 15px;
}
.letter_index {
  z-index: 999;
}
.letter_index {
  position: fixed;
  width: 23px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  padding-right: 3px;
  z-index: 99;
  top: 0;
  right: 0;
  text-align: center;
  color: #fff;
  // opacity: 0;
  transition: all 0.3s;
}
.letter_index ul {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.letter_index ul li {
  /*height: 5%;*/
  flex: 1;
}
.letter_index i {
  vertical-align: middle;
  display: inline-block;
  height: 100%;
}
.letter_index span {
  display: inline-block;
  vertical-align: middle;
}
.letter_index {
  a {
    color: #232323;
  }
}
.inpBox_inp{
  padding: 16px;

}
</style> 

<style>
.doctorList .ant-input-affix-wrapper,
.doctorList .ant-input {
  height: 36px;
  border-radius: 36px;
}
</style>